import axios from 'axios';

export default {
  namespaced: true,
  state: {
    expensereports: [],
    isFetching: false,
    isReceiving: false,
    hasAlert: false,
    isDone: false,
    errorMessage: '',
    idToDelete: null,
  },
  mutations: {
    RECEIVED_EXPENSE_REPORTS(state, payload) {
      state.expensereports = payload;
      state.isReceiving = false;
    },
    STOP_RECEIVING(state) {
      state.isReceiving = false;
    },
    RECEIVING_EXPENSE_REPORTS(state) {
      state.isReceiving = true;
    },
    EXPENSE_REPORT_FAILURE(state, payload) {
      state.isFetching = false;
      state.hasAlert = true;
      state.errorMessage = payload;
    },
    EXPENSE_REPORT_SUCCESS(state) {
      state.isFetching = false;
      state.hasAlert= false;
      state.errorMessage = '';
      state.isDone = true;
    },
    EXPENSE_REPORT_REQUEST(state) {
      state.isFetching = true;
      state.hasAlert= false;
      state.errorMessage = '';
    },
    EXPENSE_REPORT_DONE(state) {
      state.isFetching= false,
      state.hasAlert = false,
      state.isDone = false,
      state.errorMessage = ''
    }
  },
  actions: {
    async getExpenseReportByAccountRequest({dispatch}, payload) {
      try{
        dispatch("receivingExpenseReports");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/get/expensereport/byaccount';
        let response = await axios({method: "get", url: url, headers: headers, data: payload});
        dispatch("receiveExpenseReports", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getExpenseReportByLocationRequest({dispatch}, payload) {
      try{
        dispatch("receivingExpenseReports");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/get/expensereport/bylocation';
        let response = await axios({method: "get", url: url, headers: headers, data: payload});
        dispatch("receiveExpenseReports", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getExpenseReportByChannelRequest({dispatch}, payload) {
      try{
        dispatch("receivingExpenseReports");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/get/expensereport/bychannel';
        let response = await axios({method: "get", url: url, headers: headers, data: payload});
        dispatch("receiveExpenseReports", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getExpenseReportByVehicleRequest({dispatch}, payload) {
      try{
        dispatch("receivingExpenseReports");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/get/expensereport/byvehicle';
        let response = await axios({method: "get", url: url, headers: headers, data: payload});
        dispatch("receiveExpenseReports", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },

    async findExpenseReportByAccountRequest({dispatch}, payload) {
      try{
        dispatch("receivingExpenseReports");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/expensereport/byaccount';
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        dispatch("receiveExpenseReports", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async findExpenseReportByLocationRequest({dispatch}, payload) {
      try{
        dispatch("receivingExpenseReports");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/expensereport/bylocation';
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        dispatch("receiveExpenseReports", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async findExpenseReportByChannelRequest({dispatch}, payload) {
      try{
        dispatch("receivingExpenseReports");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/expensereport/bychannel';
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        dispatch("receiveExpenseReports", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async findExpenseReportByVehicleRequest({dispatch}, payload) {
      try{
        dispatch("receivingExpenseReports");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/expensereport/byvehicle';
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        dispatch("receiveExpenseReports", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async findExpenseReportPayablesRequest({dispatch}, payload) {
      try{
        dispatch("receivingExpenseReports");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/expense/report/ap';
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        dispatch("receiveExpenseReports", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    receiveExpenseReport({dispatch}) {
      dispatch('receivedExpenseReport');
    },
    receiveExpenseReports({commit}, payload) {
      commit("RECEIVED_EXPENSE_REPORTS", payload)
    },
    receivingExpenseReports({commit}) {
      commit("RECEIVING_EXPENSE_REPORTS")
    },
    resetExpenseReport({commit}) {
      commit('EXPENSE_REPORT_DONE');
    },
    receivedExpenseReportSuccess({commit}) {
      commit('EXPENSE_REPORT_SUCCESS');
    },
    requestExpenseReport({commit}) {
      commit('EXPENSE_REPORT_REQUEST');
    },
  }
}
